import React from 'react';
import propTypes from 'prop-types';

const Link = (props => (
	<a
		className={`button${(props.className) ? ` ${props.className}` : ''}`}
		href={props.url}
		target={`${props.target ? props.target : '_blank'}`}
		rel={`${props.rel ? props.rel : 'external noopener'}`}
	>
		{
			props.children &&
			<span className={'button__text'}>{props.children}</span>
		}
		{
			props.icon &&
			<span className={'button__icon'}>{props.icon}</span>
		}
	</a>
));

Link.propTypes = {
	url: propTypes.string,
	children: propTypes.node.isRequired,
	target: propTypes.string,
	rel: propTypes.string,
	icon: propTypes.string,
	className: propTypes.string,
};

export default Link;
